import React from 'react';
import {
  SiKubernetes,
  SiDocker,
  SiRabbitmq, 
  SiRedis,
  SiClickhouse,
  SiLinux, 
  SiNginx, 
  SiGrafana,
  SiPrometheus,
  SiPhp, 
  SiNodedotjs,
  SiGraylog, 
  SiCloudflare,
  SiMariadb,
  SiProxmox
} from 'react-icons/si';
import { Server, Globe, Cpu } from 'lucide-react';
const TECH_STACK = [
  { name: 'Kubernetes', icon: SiKubernetes, category: 'Orchestration' },
  { name: 'Docker', icon: SiDocker, category: 'Containerization' },
  { name: 'Cloudflare', icon: SiCloudflare, category: 'Edge/Security' },
  { name: 'RabbitMQ', icon: SiRabbitmq, category: 'Messaging' },
  { name: 'Redis', icon: SiRedis, category: 'Caching' },
  { name: 'Clickhouse', icon: SiClickhouse, category: 'Analytics' },
  { name: 'MariaDB', icon: SiMariadb, category: 'Database' },
  { name: 'Proxmox', icon: SiProxmox, category: 'Virtualization' },
  { name: 'Zabbix', icon: Server, category: 'Monitoring' },
  { name: 'Graylog', icon: SiGraylog, category: 'Logging' },
  { name: 'Linux', icon: SiLinux, category: 'System' },
  { name: 'Nginx', icon: SiNginx, category: 'Server' },
  { name: 'Grafana', icon: SiGrafana, category: 'Dashboards' },
  { name: 'Prometheus', icon: SiPrometheus, category: 'Metrics' },
  { name: 'PowerDNS', icon: Globe, category: 'DNS' },
  { name: 'KEDA', icon: Cpu, category: 'Autoscaling' },
  { name: 'PHP', icon: SiPhp, category: 'Backend' },
  { name: 'Node.js', icon: SiNodedotjs, category: 'Runtime' },
];
export function TechGrid() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <div className="flex flex-col md:flex-row justify-between items-end gap-6 mb-16">
        <div className="space-y-4 text-left">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight">Technical Proficiency</h2>
          <p className="text-muted-foreground max-w-xl text-lg">
            I specialize in a high-performance stack chosen for scalability, observability, and absolute reliability.
          </p>
        </div>
        <div className="hidden md:block h-[1px] flex-1 bg-border/50 mx-12 mb-4" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {TECH_STACK.map((tech) => (
          <div
            key={tech.name}
            className="p-6 bg-card border border-border/50 rounded-2xl flex flex-col items-center justify-center gap-4 group transition-all duration-300 shadow-sm hover:shadow-md hover:-translate-y-2 hover:bg-secondary hover:border-primary/30"
          >
            <tech.icon className="w-10 h-10 text-muted-foreground/80 group-hover:text-primary transition-colors duration-300" />
            <div className="text-center">
              <div className="font-semibold text-sm group-hover:text-foreground transition-colors">{tech.name}</div>
              <div className="text-[10px] text-muted-foreground/60 uppercase tracking-widest mt-1 font-medium">{tech.category}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}